import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import {
  addAssignProductVen,
  GetVendorDetail,
  // GetAllProductListSup,
  GetAssignedProductDetailById,
  GetAllProductListNotSup,
} from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
// import "../../styles/ProductAssign.css";
import { Col, Container, Row } from "react-bootstrap";
import "../../styles/AddProduct.css";
const ProductAssign = () => {
  const { currentColor, defaultImageMode, imageMode, userID, userToken } =
    useStateContext();
  const navigate = useNavigate();

  const [CardList, setcartList] = useState([]);
  const [CardList1, setcartList1] = useState([]);
  const [CardList2, setcartList2] = useState([]);
  const [CardList3, setcartList3] = useState([]);
  const [CardList4, setcartList4] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRows1, setSelectedRows1] = useState([]);
  const [name, setname] = useState("");
  const [selectedRowIndex, setSelectedRowIndex] = useState(-1);
  const [selectedRowIndex1, setSelectedRowIndex1] = useState(-1);
  let param = useParams();

  const [formData, setFormData] = useState({
    vendor_id: "",
    assign_products: [],
  });

  const toggleSelected = (item, index) => {
    //console.log(index);
    if (selectedRowIndex === item.product_id) {
      setSelectedRowIndex(-1);
      //setSelectedRows([]);
      setSelectedRows([]);
    } else {
      setSelectedRowIndex(item.product_id);
      //setSelectedRows([]);
      setSelectedRows([item]);
    }
  };
  useEffect(() => {
    // console.log(selectedRowIndex);
  }, [selectedRowIndex]);

  const toggleSelected1 = (item) => {
    //setSelectedRows1([]);
    if (selectedRowIndex1 === item.product_id) {
      setSelectedRowIndex1(-1);
      setSelectedRows1([]);
    } else {
      setSelectedRowIndex1(item.product_id);
      setSelectedRows1([item]);
    }
  };

  const handleBackClick1 = async (event) => {
    event.preventDefault();
    TimeoutUtility.resetTimeout();
    try {
      // console.log("Back");
      navigate("/supplier");
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleAddcartClick = () => {
    //console.log(selectedRows);
    var a = null;
    const updatedItem = [...CardList1];
    if (selectedRows.length > 0) {
      const item = selectedRows[0];
      a = item.product_id;
      // console.log(item.product_id);
      const defaultProduct = {
        product_id: item.product_id,
        name: item.name,
        code: item.code,
        unit_price: item.cost_price,
        image: item.image,
        image_url: item.image_url,
        details: item.details,
        unit: item.unit,
        delivery_days: 0,
      };
      setcartList1([defaultProduct, ...updatedItem]);
      const updatedCardList1 = CardList.filter((item) => item.product_id !== a);
      setcartList(updatedCardList1);
      setSelectedRows([]);
      setSelectedRowIndex(-1);
    }
  };

  const handleAddcartClick1 = () => {
    //console.log(selectedRows1);
    var a = null;
    const updatedItem = [...CardList];
    if (selectedRows1.length > 0) {
      const item = selectedRows1[0];
      a = item.product_id;
      const updatedCardList2 = CardList3.find((item) => item.product_id === a);
      if (updatedCardList2) {
        const defaultProduct = {
          product_id: updatedCardList2.product_id,
          name: updatedCardList2.name,
          code: updatedCardList2.code,
          unit_price: updatedCardList2.unit_price,
          cost_price: updatedCardList2.unit_price,
          image: updatedCardList2.image,
          image_url: updatedCardList2.image_url,
          details: updatedCardList2.details,
          unit: updatedCardList2.unit,
          delivery_days: 0,
        };
        setcartList([defaultProduct, ...updatedItem]);
      } else {
        const updatedCardList3 = CardList4.find(
          (item) => item.product_id === a
        );
        if (updatedCardList3) {
          const defaultProduct = {
            product_id: updatedCardList3.product_id,
            name: updatedCardList3.name,
            code: updatedCardList3.code,
            unit_price: updatedCardList3.unit_price,
            cost_price: updatedCardList3.cost_price,
            image: updatedCardList3.image,
            image_url: updatedCardList3.image_url,
            details: updatedCardList3.details,
            unit: updatedCardList3.unit,
            delivery_days: 0,
          };
          setcartList([defaultProduct, ...updatedItem]);
        }
      }
      // console.log(item.product_id);
      // const defaultProduct = {
      //   product_id: item.product_id,
      //   name: item.name,
      //   code: item.code,
      //   unit_price: item.unit_price,
      //   image: item.image,
      //   details: item.details,
      //   unit: item.unit,
      //   delivery_days: 0,
      // };
      // setcartList([defaultProduct, ...updatedItem]);
      const updatedCardList1 = CardList1.filter(
        (item) => item.product_id !== a
      );
      setcartList1(updatedCardList1);
      setSelectedRows1([]);
      setSelectedRowIndex1(-1);
    }
  };

  const handleSaleOrderClick = async (e) => {
    if (CardList1.length === 0 && CardList2.length === 0) {
      alert("No product to assign.");
      return;
    }

    const updatedFormData = { ...formData };
    updatedFormData.vendor_id = param.Supplier_id;

    updatedFormData.assign_products = [];

    CardList1.forEach((product, index) => {
      const saleProduct = {
        product_id: product.product_id,
        delivery_days: product.delivery_days,
        unit_price: product.unit_price,
        notes: "Product Assigned",
      };
      updatedFormData.assign_products.push(saleProduct);
    });

    setFormData(updatedFormData);
    // console.log(updatedFormData);
    const response = await addAssignProductVen(
      updatedFormData,
      userID,
      userToken
    );
    if (response.status === 200) {
      alert("Product assigned successfully.");
    } else {
      alert("Product Fail to assign.");
      return;
    }
    window.location.reload();
  };

  const handleUnitPriceChange = (index, value) => {
    const newCartList = [...CardList1];
    newCartList[index].delivery_days = value;
    setcartList1(newCartList);
  };

  const handleUnitPriceChange1 = (index, value) => {
    const newCartList = [...CardList1];
    newCartList[index].unit_price = value;
    setcartList1(newCartList);
  };

  function truncate(source, size) {
    return source.length > size ? source.slice(0, size - 1) + "…" : source;
  }

  const formatCurrency = (number) => {
    return number.toLocaleString("en-PK", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 2,
    });
  };

  useEffect(() => {
    async function fetchData() {
      if (param.Supplier_id && userID && userToken) {
        await GetVendorDetail(param.Supplier_id, userID, userToken)
          .then(function (result) {
            setname(result.data[0].name);
          })
          .catch((err) => {
            console.log(err.message);
          });
        await GetAssignedProductDetailById(param.Supplier_id, userID, userToken)
          .then(function (result) {
            if (result.data) {
              const productList = result.data.map((item) => ({
                product_id: item.product_id,
                name: item.name,
                code: item.code,
                unit_price: item.unit_price,
                image: item.image,
                image_url: item.image_url,
                details: item.details,
                unit: item.unit_id,
                delivery_days: item.delivery_days,
              }));

              setcartList1(() => [...productList]);
              setcartList2(() => [...productList]);
              setcartList3(() => [...productList]);
            }
          })
          .catch((err) => {
            console.log(err.message);
          });

        await GetAllProductListNotSup(
          param.Supplier_id,
          userID,
          userToken
        ).then(function (result) {
          //console.log(result.data);
          if (result.data) {
            const productList = result.data.map((item) => ({
              product_id: item.product_id,
              name: item.name,
              code: item.code,
              cost_price: item.cost_price,
              unit_price: item.unit_price,
              image: item.image,
              image_url: item.image_url,
              details: item.details,
              unit: item.unit_id,
            }));

            setcartList(() => [...productList]);
            setcartList4(() => [...productList]);
          }
        });
      }
    }
    fetchData();
  }, [param.Supplier_id, userID, userToken]);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 bg-white rounded-3xl">
      <Header title="ASSIGN PRODUCTS" />

      <Container
        fluid="true"
        className="g-0 p-0 justify-end"
        style={{ paddingLeft: "8%", paddingRight: "8%", paddingTop: "18px" }}
      >
        <Row
          xs={1}
          sm={1}
          style={{
            paddingLeft: "10px",
          }}
        >
          {/* <Col md={2} className="container-col">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="label">ID: </label>
                <input
                  className="input"
                  required
                  type="text"
                  name="name"
                  value={param.Supplier_id}
                  placeholder="Sales Order"
                  readOnly
                />
              </div>
            </div>
          </Col> */}
          <Col md={2} className="container-col">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="label">Supplier: </label>
                <input
                  type="text"
                  name="email"
                  value={name}
                  placeholder="Customer Name"
                  className="input"
                  readOnly
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <br />

      {/* <div className="flex justify-center"> */}
      <Container fluid="true" className="g-0 p-0 justify-center">
        <Row>
          <Col md={5} sm={5} lg={5} className="table-container-sale03">
            {/* <div className="flex justify-center"> */}
            <div
              style={{
                height: "100%",
                borderColor: "light-gray",
                borderWidth: "1px",
                borderRadius: "10px",
              }}
            >
              <table
                className="table table-striped table-bordered"
                style={{
                  minWidth: "220px",
                }}
              >
                <thead>
                  <tr className="table-sale-tr">
                    <th style={{ width: "50px" }}>CODE</th>
                    <th style={{ width: "240px" }}>PRODUCT</th>
                    <th style={{ width: "50px" }}>UNIT</th>
                    <th style={{ width: "60px" }}>COST</th>
                  </tr>
                </thead>
                <tbody className="pos-table-body">
                  {CardList?.map((item, index) => (
                    <tr key={index} onClick={() => toggleSelected(item, index)}>
                      <td
                        style={{
                          backgroundColor:
                            selectedRowIndex !== -1 &&
                            selectedRowIndex === item.product_id
                              ? "lightblue"
                              : "transparent",
                        }}
                      >
                        {item.code}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            selectedRowIndex !== -1 &&
                            selectedRowIndex === item.product_id
                              ? "lightblue"
                              : "transparent",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                          }}
                        >
                          {defaultImageMode &&
                            imageMode &&
                            (item.image || item.image_url) && (
                              <div
                                className="image flex gap-4"
                                style={{
                                  maxWidth: "72px",
                                  maxHeight: "72px",
                                  flex: "0 0 20%",
                                }}
                              >
                                <img
                                  className="rounded-xl"
                                  src={
                                    item.image_url
                                      ? `${item.image_url}`
                                      : `data:image/jpeg;base64,${item.image}`
                                  }
                                  alt={`Product ${item.code}`}
                                />
                              </div>
                            )}
                          <div
                            style={{
                              flex:
                                defaultImageMode &&
                                imageMode &&
                                (item.image || item.image_url)
                                  ? "0 0 80%"
                                  : "0 0 100%",
                              paddingTop:
                                !(
                                  defaultImageMode &&
                                  imageMode &&
                                  (item.image || item.image_url)
                                ) && "8px",
                              paddingBottom:
                                !(
                                  defaultImageMode &&
                                  imageMode &&
                                  (item.image || item.image_url)
                                ) && "7px",
                              alignSelf: "center",
                            }}
                          >
                            <div style={{ fontWeight: "bold" }}>
                              {truncate(
                                item.name,
                                defaultImageMode &&
                                  imageMode &&
                                  (item.image || item.image_url)
                                  ? 42
                                  : 48
                              )}
                            </div>
                            <div>
                              {truncate(
                                item.details,
                                defaultImageMode &&
                                  imageMode &&
                                  (item.image || item.image_url)
                                  ? 96
                                  : 120
                              )}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            selectedRowIndex !== -1 &&
                            selectedRowIndex === item.product_id
                              ? "lightblue"
                              : "transparent",
                        }}
                      >
                        {item.unit}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            selectedRowIndex !== -1 &&
                            selectedRowIndex === item.product_id
                              ? "lightblue"
                              : "transparent",
                        }}
                      >
                        {formatCurrency(item.cost_price)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* </div> */}
            </div>
          </Col>

          <Col
            md={1}
            sm={1}
            xs={1}
            lg={1}
            style={{ paddingTop: "200px", textAlign: "center" }}
          >
            <Row md={1} className="button-row justify-content-center">
              <Button
                margin="6px"
                color="white"
                bgColor={currentColor}
                text=">>"
                borderRadius="10px"
                onClick={handleAddcartClick}
              />
            </Row>
            <Row md={1} className="button-row justify-content-center">
              <Button
                margin="6px"
                color="white"
                bgColor={currentColor}
                text="<<"
                borderRadius="10px"
                onClick={handleAddcartClick1}
              />
            </Row>
          </Col>

          <Col md={6} sm={6} lg={6} className="table-container-sale03">
            {/* <div className="flex justify-end"> */}
            <div
              style={{
                height: "100%",
                borderColor: "light-gray",
                borderWidth: "1px",
                borderRadius: "10px",
              }}
            >
              <table
                className="table table-striped table-bordered"
                style={{
                  minWidth: "220px",
                }}
                // style={{
                //   border: "1px solid rgb(0, 0, 0)",
                // }}
              >
                <thead>
                  <tr className="table-sale-tr">
                    <th style={{ width: "50px" }}>CODE</th>
                    <th style={{ width: "260px" }}>PRODUCT</th>
                    <th style={{ width: "50px" }}>UNIT</th>
                    <th style={{ width: "60px" }}>COST</th>
                    <th style={{ width: "50px" }}>ETA</th>
                  </tr>
                </thead>
                <tbody className="pos-table-body">
                  {CardList1?.map((item, index) => (
                    <tr
                      key={item.product_id}
                      onClick={() => toggleSelected1(item)}
                    >
                      <td
                        style={{
                          backgroundColor:
                            selectedRowIndex1 !== -1 &&
                            selectedRowIndex1 === item.product_id
                              ? "lightblue"
                              : "transparent",
                        }}
                      >
                        {item.code}
                      </td>
                      <td
                        style={{
                          backgroundColor:
                            selectedRowIndex1 !== -1 &&
                            selectedRowIndex1 === item.product_id
                              ? "lightblue"
                              : "transparent",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                          }}
                        >
                          {defaultImageMode &&
                            imageMode &&
                            (item.image || item.image_url) && (
                              <div
                                className="image flex gap-4"
                                style={{
                                  maxWidth: "72px",
                                  maxHeight: "72px",
                                  flex: "0 0 20%",
                                }}
                              >
                                <img
                                  className="rounded-xl"
                                  src={
                                    item.image_url
                                      ? `${item.image_url}`
                                      : `data:image/jpeg;base64,${item.image}`
                                  }
                                  alt={`Product ${item.code}`}
                                />
                              </div>
                            )}
                          <div
                            style={{
                              flex:
                                defaultImageMode &&
                                imageMode &&
                                (item.image || item.image_url)
                                  ? "0 0 80%"
                                  : "0 0 100%",
                              paddingTop:
                                !(
                                  defaultImageMode &&
                                  imageMode &&
                                  (item.image || item.image_url)
                                ) && "8px",
                              paddingBottom:
                                !(
                                  defaultImageMode &&
                                  imageMode &&
                                  (item.image || item.image_url)
                                ) && "7px",
                              alignSelf: "center",
                            }}
                          >
                            <div style={{ fontWeight: "bold" }}>
                              {truncate(
                                item.name,
                                defaultImageMode &&
                                  imageMode &&
                                  (item.image || item.image_url)
                                  ? 42
                                  : 48
                              )}
                            </div>
                            <div>
                              {truncate(
                                item.details,
                                defaultImageMode &&
                                  imageMode &&
                                  (item.image || item.image_url)
                                  ? 96
                                  : 120
                              )}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                          backgroundColor:
                            selectedRowIndex1 !== -1 &&
                            selectedRowIndex1 === item.product_id
                              ? "lightblue"
                              : "transparent",
                        }}
                      >
                        {item.unit}
                      </td>

                      <td
                        style={{
                          textAlign: "center",
                          backgroundColor:
                            selectedRowIndex1 !== -1 &&
                            selectedRowIndex1 === item.product_id
                              ? "lightblue"
                              : "transparent",
                        }}
                      >
                        {/* <AiOutlineMinusSquare /> */}

                        <div className="centered-input">
                          <input
                            className="input"
                            id="quantity"
                            type="number"
                            step="1.00"
                            min="0"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                            }}
                            value={item.unit_price}
                            onChange={(e) =>
                              handleUnitPriceChange1(index, e.target.value)
                            }
                          />
                        </div>
                      </td>

                      <td
                        style={{
                          textAlign: "center",
                          backgroundColor:
                            selectedRowIndex1 !== -1 &&
                            selectedRowIndex1 === item.product_id
                              ? "lightblue"
                              : "transparent",
                        }}
                      >
                        <div className="centered-input">
                          <input
                            className="input"
                            id="delivery_days"
                            type="number"
                            step="1.00"
                            min="0"
                            style={{
                              textAlign: "center",
                              fontSize: "12px",
                            }}
                            value={item.delivery_days}
                            onChange={(e) =>
                              handleUnitPriceChange(index, e.target.value)
                            }
                          />
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            {/* </div> */}
          </Col>
        </Row>
      </Container>
      <br />
      <br />
      <Row md={"auto"} className="justify-content-center">
        <button
          style={{
            padding: "10px",
            backgroundColor: currentColor,
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            margin: "10px",
          }}
          color="white"
          borderradius="10px"
          onClick={handleSaleOrderClick}
          text="heh"
          // disabled={!forceUpdate}
        >
          Assign
        </button>
        <button
          style={{
            padding: "10px",
            backgroundColor: currentColor,
            color: "#fff",
            border: "none",
            borderRadius: "5px",
            margin: "10px",
          }}
          color="white"
          borderradius="10px"
          onClick={handleBackClick1}
          text="heh"
          // disabled={!forceUpdate}
        >
          Back
        </button>
      </Row>
    </div>
  );
};

/* <Col
            md={1}
            sm={true}
            className="d-block d-lg-none flex justify-center"
          >
            <Button
              margin="6px"
              color="white"
              bgColor={currentColor}
              text=">>"
              borderradius="10px"
              onClick={handleAddcartClick}
            />
            <br />
            <Button
              margin="6px"
              color="white"
              bgColor={currentColor}
              text="<<"
              borderradius="10px"
              onClick={handleAddcartClick1}
            />
          </Col> */
/* <Col md={1} className="container-col">
            <div style={{ marginTop: "200px", width: "0" }}>
              <button
                style={{
                  padding: "10px",
                  backgroundColor: currentColor,
                  color: "#fff",
                  border: "none",
                  borderradius: "5px",

                  // margin: "10px",
                }}
                color="white"
                borderradius="10px"
                onClick={handleAddcartClick}
                text="heh"
              >
                {">>"}
              </button>
              <br />

              <button
                style={{
                  padding: "10px",
                  backgroundColor: currentColor,
                  color: "#fff",
                  border: "none",
                  borderradius: "5px",
                  // margin: "10px",
                }}
                color="white"
                borderradius="10px"
                onClick={handleAddcartClick1}
                text="heh"
                // disabled={!forceUpdate}
              >
                {"<<"}
              </button>
            </div>
          </Col> */

export default ProductAssign;
